/* Ventana del 10% (v7.1). Aparece una vez cada 14 dias, a los 12 s o
   cuando el mouse se va de la pagina. Nunca en el carrito ni si la
   persona ya dejo su correo.

   Despues de enviar, Shopify recarga con ?customer_posted=true: ahi la
   ventana se abre sola en el paso 2 (el codigo) y el descuento se deja
   aplicado en el carrito sin que la persona haga nada. */
(function () {
  var pop = document.getElementById('pop-cupon');
  if (!pop) return;

  var LLAVE = 'tlr-pop-cupon';
  var DIAS = 14;
  var codigo = pop.getAttribute('data-codigo') || '';
  var ruta = document.body.className || '';

  function visto() {
    try {
      var v = localStorage.getItem(LLAVE);
      if (!v) return false;
      if (v === 'ya') return true;
      return (Date.now() - parseInt(v, 10)) < DIAS * 864e5;
    } catch (e) { return true; }
  }
  function marcar(valor) { try { localStorage.setItem(LLAVE, valor || String(Date.now())); } catch (e) {} }
  function mostrar() { if (typeof pop.showModal === 'function') { if (!pop.open) pop.showModal(); } else { pop.setAttribute('open', ''); } }
  function cerrar() { if (typeof pop.close === 'function') { pop.close(); } else { pop.removeAttribute('open'); } }

  pop.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-pop-x]')) { cerrar(); return; }
    if (ev.target === pop) { cerrar(); return; }
    var copiar = ev.target.closest('[data-pop-copy]');
    if (copiar) {
      var c = copiar.getAttribute('data-code');
      if (navigator.clipboard) { navigator.clipboard.writeText(c); }
      copiar.textContent = 'Código copiado';
    }
  });

  /* La casilla decide la etiqueta que recibe el cliente en Shopify. */
  var tags = pop.querySelector('[data-pop-tags]');
  var casilla = pop.querySelector('[data-pop-novedades]');
  if (tags && casilla) {
    casilla.addEventListener('change', function () {
      tags.value = 'popup-10, ' + (casilla.checked ? 'novedades-si' : 'novedades-no');
    });
  }
  var form = pop.querySelector('form');
  if (form) { form.addEventListener('submit', function () { marcar('ya'); }); }

  var enviado = location.search.indexOf('customer_posted=true') !== -1;
  var conError = !!pop.querySelector('.pop-error');

  if (enviado) {
    marcar('ya');
    var p1 = pop.querySelector('[data-pop-paso="1"]'), p2 = pop.querySelector('[data-pop-paso="2"]');
    if (p1) p1.hidden = true;
    if (p2) p2.hidden = false;
    if (codigo) { fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' }).catch(function () {}); }
    mostrar();
    return;
  }
  if (conError) { mostrar(); return; }

  /* Para probar: ?cupon=1 la abre al instante. */
  if (location.search.indexOf('cupon=1') !== -1) { mostrar(); return; }

  if (ruta.indexOf('plantilla-cart') !== -1 || visto()) return;

  var abierto = false;
  function abrir() {
    if (abierto || visto()) return;
    abierto = true;
    marcar();
    mostrar();
  }
  var reloj = setTimeout(abrir, 12000);
  document.addEventListener('mouseout', function (ev) {
    if (!ev.relatedTarget && ev.clientY <= 0) { clearTimeout(reloj); abrir(); }
  });
})();